let LOCALSTORAGE_ENABLED = false;
const localStorage = window.localStorage;

try {
  const randKey = Math.round(Math.random() * 100000000) + '';
  localStorage.setItem(randKey, randKey);
  localStorage.getItem(randKey);
  localStorage.removeItem(randKey);
  LOCALSTORAGE_ENABLED = true;
} catch (e) {
  LOCALSTORAGE_ENABLED = false;
}

const PREFIX = 'dh3E9dahn3';

const ns = (key: string): string => PREFIX + key;

export function writeToStorage(key: string | null, value: any | null) {
  if (!key || !value) return;

  if (LOCALSTORAGE_ENABLED) {
    localStorage.setItem(ns(key), JSON.stringify(value));
  } else {
    setCookie(ns(key), JSON.stringify(value), 2);
  }
}

export function readFromStorage(key: string | null) {
  if (!key) return;

  if (LOCALSTORAGE_ENABLED) {
    const item = localStorage.getItem(ns(key)) || 'null';
    return JSON.parse(item);
  } else {
    return getCookie(ns(key));
  }
}

export function removeFromStorage(key: string | null) {
  if (!key) return;

  if (LOCALSTORAGE_ENABLED) {
    return localStorage.removeItem(ns(key));
  } else {
    removeCookie(ns(key));
  }
}

function setCookie(cname: string, cvalue: string | null = '', exdays: number) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname: string) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function removeCookie(cname: string) {
  setCookie(cname, null, 0);
}
